import { Product } from "@shopify/hydrogen-react/storefront-api-types"

import { useConfigContext } from "@app/providers/config"

// potential to move stockStatuses to sanity config, if so then move values to app config
const stockStatuses: { [key: string]: string } = {
  "coming-soon": "Coming Soon",
  "back-soon": "Notify Me",
  "in-store": "In Store Only",
  "out-of-stock": "Out of Stock",
}

export const useOutOfStock = (product: Product) => {
  const { settings } = useConfigContext()
  if (!product?.tags) {
    console.error("No tags on product")
    return { stockStatus: null, isNotifyFlow: false }
  }

  const stockTagPrefix = product.tags.find(tag => tag.includes("stock:"))
  const stockValue = stockTagPrefix ? stockTagPrefix.split(":")[1] : null
  const stockStatus = stockValue && stockStatuses[stockValue] ? stockStatuses[stockValue] : null

  const isNotifyFlow = stockValue === settings.product.comingSoon || stockValue === settings.product.backSoon
  const isDisabledFlow = stockValue === settings.product.inStore || stockValue === settings.product.outOfStock
  const isInStoreOnly = stockValue === settings.product.inStore

  return {
    stockStatus,
    stockValue,
    isNotifyFlow,
    isDisabledFlow,
    isInStoreOnly,
  }
}
